import { render, staticRenderFns } from "./TasksKanban.vue?vue&type=template&id=c176f3b0&"
import script from "./TasksKanban.vue?vue&type=script&lang=js&"
export * from "./TasksKanban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports